import IconButton from 'common/components/IconButton';
import SearchInput from 'common/components/SearchInput';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import { ReactComponent as SortIcon } from 'common/icons/sort.svg';
import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as EditIcon } from './icons/Edit.svg';
import './index.css';
import { WriteButton } from './styles/WriteButton';
import { MailScroller } from './styles/MailScroller';
import styled from '@emotion/styled';
import Checkbox from 'common/components/Checkbox';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';

const MailLineWrapper = styled.div`
  display:flex;
  align-items: center;
  padding: 20px 28px 20px 4px;
  gap: 16px;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
`;

const MailLineHover = styled.div`
  padding: 0 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    // + 10% opacity
    background-color: ${({ theme }) => theme.colors.primaryColor + '1A'};
  }
  &.active {
    // + 25% opacity
    background-color: ${({ theme }) => theme.colors.primaryColor + '40'};
  }
`;

type MailLineProps = {
  id: number | string;
  title: string;
  text: string;
  time: string;
};

function createMockMailList(numMails: number): MailLineProps[] {
  const mailList: MailLineProps[] = [];
  const titles = ['Hello', 'Meeting', 'Reminder', 'Updates', 'Important'];
  const texts = ['Please join the meeting', 'Don\'t forget to bring your laptop', 'See you soon!', 'Here are the updates', 'This is important'];
  const times = ['10:00 AM', '12:30 PM', '3:45 PM', '5:15 PM', '8:00 PM'];
  for (let i = 0; i < numMails; i++) {
    const randomTitle = titles[Math.floor(Math.random() * titles.length)];
    const randomText = texts[Math.floor(Math.random() * texts.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    mailList.push({ id: i, title: randomTitle, text: randomText, time: randomTime });
  }
  return mailList;
}

const MailLine = ({ id, title, text, time }: MailLineProps) => {
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const handleCheckboxClick = (e:React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    setIsSelected(!isSelected);
  };
  const handleFavoriteClick = (e:React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    setIsFavorite(!isFavorite);
  };
  const NavigateToMail = (e) => {
    console.log(e.target);
    navigate(`${id}`);
  };
  return (
    <MailLineHover className={isSelected ? 'active' : null} onClick={NavigateToMail}>
      <MailLineWrapper>
        <div className='mail-line-section'>
          <Checkbox checked={isSelected} onChange={handleCheckboxClick} size={18} marginRight={8} />
          <Checkbox checked={isFavorite} onChange={handleFavoriteClick} size={20} marginRight={23} icon={<BookmarkBorderIcon />} checkedIcon={<BookmarkIcon />} />
          <span className='mail-line-title'>{title}</span>
          <span className='mail-line-text'>{text}</span>
        </div>
        <span className='mail-line-time'>{time}</span>
      </MailLineWrapper>
    </MailLineHover>
  );
};


export default function MailPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search') || '';
  const [searchValue, setSearchValue] = useState(search);
  const mailList = useMemo(() => createMockMailList(30), []);

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  const handleSearchSubmit = (value: string) => {
    if (value) {
      searchParams.set('search', value);
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams, { replace: true });
  };
  return (
    <div className="mail-section">
      <div className='mail-menu-line'>
        <div className='contacts-menu-wrapper'>
          <SearchInput value={searchValue} onChange={handleSearchChange} searchFunction={handleSearchSubmit} />
          <IconButton label='Фільтри'>
            <FilterIcon className='svg-black' />
          </IconButton>
          <IconButton label='Сортування'>
            <SortIcon className='svg-black' />
          </IconButton>
        </div>
        <div className='contacts-menu-wrapper'>
          <WriteButton>
            Написати
            <EditIcon className='svg-black svg-fill' />
          </WriteButton>
        </div>
      </div>
      <MailScroller>
        <div className='mail-list scrollbar'>
          {mailList.map((mail) => (
            <MailLine key={mail.id} id={mail.id} title={mail.title} text={mail.text} time={mail.time} />
          ))}
        </div>
      </MailScroller>
    </div>
  );
}